import React, { FC, useRef } from "react";
import type { PlatformInclusivePaymentOptionsProps } from "@/types";
import { ContentManager } from "../content-manager";
import SplitTextAnimation from "../split-text-animation";
import { useInView } from "@/hooks/reveal-in-view";

export const PlatformInclusivePaymentOptions: FC<PlatformInclusivePaymentOptionsProps> = ({
  content,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <section ref={ref} className="platformInclusivePaymentOptions">
      <SplitTextAnimation
        htmlElement={
          <ContentManager
            content={content}
            className="platformInclusivePaymentOptions--content"
          />
        }
        isInView={isInView}
      />
    </section>
  );
};
